import { Box } from 'rebass/styled-components';
import styled from 'styled-components';

import Media from '../../../utils/Media';

export const StyledTitle = styled(Box)`
  font-size: 40px;
  line-height: 1.2;
  color: ${({ theme }) => theme.text.heading.color ?? theme.colors.text};
  margin-bottom: 16px;
  word-break: break-word;
`;

export const StyledDescription = styled(Box)`
  font-size: 20px;
  line-height: 1.5;
  color: ${props => props.theme.colors.darkGrey};
`;

export const StyledCardList = styled(Box)`
  display: flex;
  align-items: top;
  justify-content: left;

  ${Media({
    flexWrap: ['wrap', null, null, 'nowrap'],
    position: ['relative', null, null, 'static'],
  })}

  > *:not(:last-child) {
    ${Media({
      marginBottom: ['1rem', '0px', null, null],
    })}
  }
`;

export const StyledCardContainer = styled(Box)`
  > div:first-child {
    max-width: 100%;
  }

  ${Media({
    marginRight: [null, null, null, '3.5rem'],
    width: ['100%', null, 'calc(50% - 0.5rem)', 'calc(33.33% - 3.5rem)'],
  })}

  &:nth-child(odd) {
    ${Media({
      marginRight: [null, null, '1rem', '3.5rem'],
    })}
  }
`;
